'use memo';

import { useEffect } from 'react';
import type { AiChatModel } from '@/features/global-ai-chat/api/types';
import { useGlobalAiChatStore } from '@/features/global-ai-chat/store/globalAiChatStore';

/**
 * 初回ロード時、selectedModelId 未設定なら既定モデル（isDefault）を選択する。
 * isDefault が無い場合は先頭モデルにフォールバックする。
 */
export function useDefaultAiChatModel(models: AiChatModel[]): void {
  const selectedModelId = useGlobalAiChatStore(state => state.selectedModelId);
  const setSelectedModelId = useGlobalAiChatStore(state => state.setSelectedModelId);
  useEffect(() => {
    if (selectedModelId) return;
    const defaultModelId = models.find(model => model.isDefault)?.id ?? models[0]?.id;
    if (defaultModelId) {
      setSelectedModelId(defaultModelId);
    }
  }, [models, selectedModelId, setSelectedModelId]);
}